export const leadsScoreTips = {
  intentionScoreTag: [
    { enumValue: '0', enumDetail: '默认值或号码无效，空号、暂停服务、与资料不符，二次拨打仍未接通' },
    { enumValue: '0~20', enumDetail: '关机、来电提醒、无人接听、未接通等情况，需再次拨打' },
    { enumValue: '20~40', enumDetail: '匆匆挂断电话，QQ、微信等不联系，或强硬抵触' },
    {
      enumValue: '40~60',
      enumDetail: '没有感兴趣的话语体现，不排斥但意愿也不强烈，或没有时间详细沟通但可以再约通话时间',
    },
    { enumValue: '60~80', enumDetail: '较有兴趣，但需要进一步了解产品情况' },
    { enumValue: '80~100', enumDetail: '很感兴趣，也觉得平台可以，或可以来公司约谈的' },
  ],
  carScoreTag: [
    { enumValue: '0', enumDetail: '“联系方式”为无效号码、空号、暂停服务、可疑数据等线索' },
    { enumValue: '0~20', enumDetail: '已知“联系方式”的线索' },
    { enumValue: '20~40', enumDetail: '已知“联系方式”且“近期购买意向”为“无”的线索' },
    { enumValue: '40~60', enumDetail: '已知“联系方式”且“近期购买意向”为“有”的线索' },
    { enumValue: '60~80', enumDetail: '已知“联系方式”且“近期购买意向”为“有”且已知1个“意向细节”字段的线索' },
    { enumValue: '80~100', enumDetail: '已知“联系方式”且“近期购买意向”为“有”且已知多个“意向细节”字段的线索' },
  ],
};

export const leadsSubTypeTips = {
  tag: [
    { enumValue: '智能电话', enumDetail: '用户拨打智能电话' },
    { enumValue: '智能咨询', enumDetail: '用户使用智能咨询留下线索' },
    { enumValue: '发券', enumDetail: '用户通过卡券留下线索' },
    { enumValue: '抽奖', enumDetail: '用户通过抽奖留下线索' },
    { enumValue: '表单预约-提交表单', enumDetail: '用户在提交表单时，通过手动填写手机号码提交表单' },
    { enumValue: '表单预约-留资咨询', enumDetail: '用户使用智能咨询留下线索（上报OCPX “表单预约”优化目标）' },
    { enumValue: '表单预约-电话咨询', enumDetail: '用户拨打智能电话（上报OCPX “表单预约”优化目标）' },
    { enumValue: '一键授权-提交表单', enumDetail: '用户在提交表单时，通过一键授权手机号码提交表单' },
    { enumValue: '一键授权-开口咨询', enumDetail: '用户在小程序内向销售顾问发起咨询' },
    { enumValue: '一键授权-点击表单', enumDetail: '用户在提交表单时，仅一键授权手机号码，实际未提交表单' },
    { enumValue: '一键授权-点击咨询', enumDetail: '用户在发起咨询时，仅一键授权手机号码，实际未发起对话' },
    { enumValue: '一键授权-点击拨打', enumDetail: '用户点击页面400电话按钮，并一键授权手机号码' },
  ],
};

export const callResultTips = [
  { enumValue: '待联系', enumDetail: '市场推广获取线索后，线索初始状态' },
  { enumValue: '未接通-无效号码', enumDetail: '电话空号、停机' },
  { enumValue: '未接通-其他', enumDetail: '除无效号码以外的未接通情况' },
  { enumValue: '已接通-未回应', enumDetail: '给用户拨打过电话，电话已接通但是通话时间小于10s' },
  { enumValue: '已接通-已回应', enumDetail: '给用户拨打过电话，电话已接通但是通话时间大于等于10s' },
];

export const leadsTagTips = [
  // {enumValue: "电话异常", enumDetail: "如批量注册的垃圾账号，可能在后续欺诈中使用。"},
  { enumValue: '电话重复', enumDetail: '新线索与过去两周的线索进行重复判别，若电话一致，则认为是电话重复。' },
  // {enumValue: "分享注册", enumDetail: "表示当前用户是在其他人转发分享的页面提交的个人信息。"},
  { enumValue: '疑似空号', enumDetail: '该号码尚未被运营商登记，暂时无法接通。' },
  // {
  //   enumValue: '可疑数据',
  //   enumDetail:
  //     '表示系统识别为用户异常提交的线索，有效率偏低，该类线索不计成本，也不在投放端转化量统计范畴内，核算有效成本时，请排除后再核算。',
  // },
  {
    enumValue: '合约',
    enumDetail: '该线索来源于合约广告。',
  },
  {
    enumValue: '重复注册',
    enumDetail: '用户在浏览广告时当天重复提交的线索被判定为重复注册，该类线索不计成本，也不在投放端转化量统计范畴内，核算有效成本时，请排除后再核算。',
  },
  { enumValue: '机器人接待', enumDetail: '智能电话由机器人接听。' },
  { enumValue: '参与赔付', enumDetail: '无效赔付政策参与对象：推广计划设置的出价方式为OCPC、OCPM，第一优化目标为表单预约／综合线索收集／有效线索收集，线索来源包含蹊径落地页、微信原生推广页、广告附加创意组件、讯达小程序、互动落地页，线索类型为表单预约-提交表单的线索。' },
  {
    enumValue: '确认赔付',
    enumDetail:
      '该线索已通过系统智能验证是空号／停机／关机，符合赔付范围。（注：该标签生效的前提为该账户当月满足48小时内参与赔付线索标记率>=50%。若未满足该前提条件，即使打上确认赔付标签也无法真实发放赔付款。)',
  },
  {
    enumValue: '上报ID重复',
    enumDetail: '该类线索不会计入投放端报表转化目标统计量，不计成本。',
  },
  {
    enumValue: '点击ID重复',
    enumDetail: '线索引入时判断其点击ID是否和历史30天内线索的点击ID重复，若重复即认为点击ID重复，常见于用户分享后留资或同一用户多次留资产生多条线索。对于非mp流量的线索，若点击ID重复则不计入投放端报表模块目标转化量，不参与无效赔付。',
  },
];

export const leadsCallCleaningTagTips = [
  { enumValue: '正常号码', enumDetail: '针对参与赔付范围触发无效验证的线索，系统验证结果为正常号码，建议再次拨打继续跟进。' },
  { enumValue: '未接通', enumDetail: '针对参与赔付范围触发无效验证的线索，系统验证结果为未接通，建议增加拨打次数提升接通率。' },
  { enumValue: '关机', enumDetail: '针对参与赔付范围触发无效验证的线索，系统验证结果为关机，确认赔付。' },
  { enumValue: '无效号码', enumDetail: '针对参与赔付范围触发无效验证的线索，系统验证结果为空号或停机，确认赔付。' },
  { enumValue: '机器人-高意向', enumDetail: '广告主开启智能外呼，机器人外呼沟通过程中，用户表达有意愿的外呼结果。' },
  { enumValue: '机器人-低意向', enumDetail: '广告主开启智能外呼，机器人外呼状态为已接通，用户表达意愿较低。' },
  { enumValue: '机器人-无意向', enumDetail: '广告主开启智能外呼，机器人外呼状态为已接通，但是用户表示无意向。' },
  { enumValue: '机器人-未接通', enumDetail: '广告主开启智能外呼，机器人外呼状态为未接通，多为用户挂断、用户忙等场景。' },
  { enumValue: '机器人-无效', enumDetail: '广告主开启智能外呼，机器人外呼状态为无效号码，包括停机、关机、空号场景。' },
  { enumValue: '机器人-待联系', enumDetail: '广告主开启智能外呼，线索在智能外呼的范围内，但当前尚未完成外呼任务。' },
];
